import { Controller } from "@hotwired/stimulus"

// Copies a license key (or any short text) to the clipboard on click.
export default class extends Controller {
  static targets = ["status"]
  static values = { text: String }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.textValue)
      this.statusTarget.textContent = "Copied."
    } catch (error) {
      this.statusTarget.textContent = "Copy failed. Select the text and copy it."
    }
  }
}
